import * as types from "../types/break.types";
import moment from "moment";

const initialFilter = {
  storeIds: [],
  status: [],
  keysearch: "",
  zones: [],
  riderId: "",
  reasons: [],
  currentPage: 1,
  limit: 10,
  startDate: moment(),
  endDate: moment(),
};

const initialState = {
  taskData: [],
  taskPagination: [],
  taskFilter: {
    ...initialFilter,
  },
};

const BreakReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_TASK_DATA:
      return { ...state, taskData: action.payload };
    case types.SET_TASK_PAGINATION:
      return { ...state, taskPagination: action.payload };
    case types.SET_TASK_FILTER:
      return { ...state, taskFilter: action.payload };
    case types.RESET_BREAK_REDUCER:
      return {
        ...state,
        taskData: [],
        taskPagination: [],
        taskFilter: {
          ...initialFilter,
        },
      };
    default:
    return state;
  }
};
export default BreakReducer;
